import React from 'react';
import { View, Text, TextInput, StyleSheet } from 'react-native';

interface RateInputProps {
  label: string;
  value: string;
  onChange: (text: string) => void;
  est?: number | null;
  unit?: string;
}

const RateInput: React.FC<RateInputProps> = ({ label, value, onChange, est, unit = '/kWh' }) => {
    const estNumber = typeof est === 'number' ? est : parseFloat(est as any);
    const isValidEstimate = !isNaN(estNumber) && isFinite(estNumber);
    
    return (
        <View style={styles.wrapper}>
            <Text style={styles.label}>{label} ({unit})</Text>
            <View style={styles.row}>
            <Text style={styles.dollar}>$</Text>
            <TextInput
                style={styles.input}
                value={value}
                onChangeText={onChange}
                placeholder="0.00"
                placeholderTextColor="#8D8E90"
                keyboardType="decimal-pad"
                autoComplete='off'
                autoCorrect={false}
            />
            <Text style={styles.unit}>{unit}</Text>
            {isValidEstimate && 
                <Text style={styles.est}>
                    (Est: ${estNumber.toFixed(2)})
                </Text>
            }
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
  wrapper: { marginBottom: 16 },
  label: { color: '#fff', marginBottom: 4, fontWeight: '600' },
  row: { flexDirection: 'row', alignItems: 'center' },
  dollar: { color: '#fff', fontWeight: '600', fontSize: 24, marginRight: 4 },
  input: { backgroundColor: '#234D4E', color: '#fff', padding: 12, borderRadius: 30, flex: 1 },
  unit: { color: '#8D8E90', fontWeight: '600', fontSize: 14, marginLeft: 6 },
  est: { color: 'red', marginLeft: 8 },
});

export default RateInput;